// extracted by mini-css-extract-plugin
export var numpadContainer = "_si-1";
export var phoneButton = "_si-0";